export const BASE_URL = {
  // baseUrl: "http://hs.bitxoom.com/api/",
  // baseUrl: "https://hairscouttestmobileapp.azurewebsites.net/api/",
  //baseUrl: "https://hsdevapi.hairscoutwebapp.com/api/",
  baseUrl: "https://hsappapi.hairscoutwebapp.com/api/",
};
